export class DataServiceInterface {
  static async initialLoad (params) {
    throw new Error('Not implemented')
  }

  static async getMessages (params) {
    throw new Error('Not implemented')
  }

  static async getEconomicEfficienty (params) {
    throw new Error('Not implemented')
  }

  static async getTendersCount (params) {
    throw new Error('Not implemented')
  }

  static async getTendersSum (params) {
    throw new Error('Not implemented')
  }

  static async getOffersCount (params) {
    throw new Error('Not implemented')
  }

  static async getTendersAvgTimeSpending (params) {
    throw new Error('Not implemented')
  }

  static async getTendersAvgTimeDuration (params) {
    throw new Error('Not implemented')
  }

  static async getCountCompaniesInvitedByOrg (params) {
    throw new Error('Not implemented')
  }

  static async getCountCompaniesInvitedByTpro (params) {
    throw new Error('Not implemented')
  }

  static async getProvidersTop10 (params) {
    throw new Error('Not implemented')
  }

  static async getCriticalIndicators (params) {
    throw new Error('Not implemented')
  }

  static async getClaims (params) {
    throw new Error('Not implemented')
  }

  static async getClaimsStats (params) {
    throw new Error('Not implemented')
  }

  static async getClaimDetails (params) {
    throw new Error('Not implemented')
  }

  static async getProcedures (params) {
    throw new Error('Not implemented')
  }

  static async getProceduresStats (params) {
    throw new Error('Not implemented')
  }

  static async getProcedureDetails (id) {
    throw new Error('Not implemented')
  }

  static async getProcedureWinners (params) {
    throw new Error('Not implemented')
  }

  static async getCompanies (companiesIds) {
    throw new Error('Not implemented')
  }

  static async getManagers (params) {
    throw new Error('Not implemented')
  }

  static async getDepartments (params) {
    throw new Error('Not implemented')
  }

  static async getContracts (params) {
    throw new Error('Not implemented')
  }

  static async getContractStatuses (params) {
    throw new Error('Not implemented')
  }

  static async getOrders (params) {
    throw new Error('Not implemented')
  }

  static async getOrderStatuses (params) {
    throw new Error('Not implemented')
  }

  /*
  userIds - список ID пользователей
  */
  static async getUsers (userIds) {
    throw new Error('Not implemented')
  }

  static async getProducts (params) {
    throw new Error('Not implemented')
  }

  static async getUnits (params) {
    throw new Error('Not implemented')
  }

  static async getCurrencies (params) {
    throw new Error('Not implemented')
  }

  /*
    entityCode: код сущности для которой надо отобразить сквозную связку = 'claim' | 'procedure' | 'contract' | 'code'
    entityId: идентификатор сущности
  */
  static async getCrossEntitiesRelations ({ entityCode, entityId }) {
    throw new Error('Not implemented')
  }

  static async generateReport (params) {
    throw new Error('Not implemented')
  }

  static async getDocumentTemplates (params) {
    throw new Error('Not implemented')
  }

  static async createDocumentTemplate (params) {
    throw new Error('Not implemented')
  }

  static async getDocuments (params) {
    throw new Error('Not implemented')
  }

  static async renderDocumentTemplate (params) {
    throw new Error('Not implemented')
  }

  static async getCompanyInfo (params) {
    throw new Error('Not implemented')
  }

  static async getUserInfo (params) {
    throw new Error('Not implemented')
  }
}
